import React from 'react';
import { connect } from 'react-redux';
import {
  FormGroup,
  Label,
  Card,
  ButtonGroup,
  Button,
} from 'reactstrap';
import Input from '../../Input';
import FileUpload from '../../FileUpload';
import ImageDisplay from '../../ImageDisplay';
import RichTextEditor from './RichTextEditor';

class ContentBox extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      numOfButtons: 0,
    };
  }

  componentDidMount() {
    const { values, contentBoxNumber } = this.props;
    const contentBoxValues = values[`contentBox${contentBoxNumber}`] && values[`contentBox${contentBoxNumber}`].buttons;

    if (contentBoxValues) {
      this.setState({ numOfButtons: values[`contentBox${contentBoxNumber}`].buttons.length });
    }
  }

  addButton = (e) => {
    const { numOfButtons } = this.state;
    const { dispatch } = this.props;
    if (numOfButtons < 5) {
      this.setState((prevState) => ({
        numOfButtons: prevState.numOfButtons + 1,
      }));
    }
    dispatch({
      type: 'ADD_CONTENT_BOX_BUTTON',
      category: e.target.id,
    });
  };

  removeButton = (e) => {
    const { numOfButtons } = this.state;
    const { dispatch } = this.props;
    if (numOfButtons !== 0) {
      this.setState((prevState) => ({
        numOfButtons: prevState.numOfButtons - 1,
      }));
    }
    dispatch({
      type: 'REMOVE_CONTENT_BOX_BUTTON',
      category: e.target.id,
    });
  };

  renderMessage = () => {
    const { numOfButtons } = this.state;
    switch (numOfButtons) {
      case 0:
        return <div className="text-muted">No Buttons.</div>;
      case 5:
        return <div className="text-muted">Maximum Buttons Reached</div>;
      default:
        return null;
    }
  };

  render() {
    const { numOfButtons } = this.state;
    const { contentBoxNumber, values } = this.props;

    return (
      <FormGroup>
        <div className="d-flex justify-content-between align-items-center">
          <Label className="font-weight-bold">
            Content Box&nbsp;
            {contentBoxNumber}
          </Label>
        </div>
        <Card className="p-2">
          <FileUpload id={`contentBox${contentBoxNumber}Image`} label="Image:" />
          <ImageDisplay id={`contentBox${contentBoxNumber}Image`} />
          <RichTextEditor
            id="body"
            categoryType="object"
            category={`contentBox${contentBoxNumber}`}
          />
          <div className="mb-2 d-flex align-items-center">
            <Label className="font-weight-bold me-3 mb-0">
              Learn More Buttons
            </Label>
            <ButtonGroup className="me-3">
              <Button
                style={{ borderTopLeftRadius: '50%', borderBottomLeftRadius: '50%' }}
                onClick={this.removeButton}
                className="content-buttons-edit"
                disabled={numOfButtons < 1}
                id={`contentBox${contentBoxNumber}`}
                outline
              >
                -
              </Button>
              <Button
                style={{ borderTopRightRadius: '50%', borderBottomRightRadius: '50%' }}
                onClick={this.addButton}
                className="content-buttons-edit"
                id={`contentBox${contentBoxNumber}`}
                disabled={numOfButtons > 4}
              >
                +
              </Button>
            </ButtonGroup>
            {this.renderMessage()}
          </div>
          {
            Array.from({ length: numOfButtons }, (_, k) => (
              <Card className="p-2 mb-1" key={k}>
                <Label>
                  Button&nbsp;
                  {k + 1}
                </Label>
                <Input
                  id="name"
                  label="Button Text:"
                  categoryType="arrayWithinObject"
                  category={`contentBox${contentBoxNumber}`}
                  buttonNumber={k}
                  objectKey="buttons"
                  value={values[`contentBox${contentBoxNumber}`] && values[`contentBox${contentBoxNumber}`].buttons && values[`contentBox${contentBoxNumber}`].buttons[k]
                    ? values[`contentBox${contentBoxNumber}`].buttons[k].name : null}
                />
                <Input
                  id="url"
                  label="Button Link:"
                  categoryType="arrayWithinObject"
                  buttonNumber={k}
                  objectKey="buttons"
                  category={`contentBox${contentBoxNumber}`}
                  value={values[`contentBox${contentBoxNumber}`] && values[`contentBox${contentBoxNumber}`].buttons && values[`contentBox${contentBoxNumber}`].buttons[k]
                    ? values[`contentBox${contentBoxNumber}`].buttons[k].url : null}
                />
              </Card>
            ))
          }
        </Card>
      </FormGroup>
    );
  }
}

const mapStateToProps = (store) => ({
  values: store.sites.values,
});

export default connect(mapStateToProps)(ContentBox);
